<template>
<div id="ag-grid-demo">

  <vx-card>
    <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
      <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
        <vs-button
          class="mt-3"
          @click="$router.push({ name: 'Company_admin_DIDs_list' })"
        >Back to Invoice</vs-button>
      </div>
     <!-- <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
        <vs-button
          class="mt-3 mr-6"
          :disabled="!validateForm"
        >Generate Invoice</vs-button>
        <vs-button
          class="mt-3"
          @click="Add"
        >Add Invoice</vs-button>
      </div>-->
    </div>
  </vx-card>
<!--  <vx-card>-->
<!--    <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">-->
<!--      <div class="filters-container flex flex-wrap items-center justify-start">-->

<!--        <div style="padding: 11px">-->
<!--          <smsc-col>-->
<!--            <smsc-col-item :col-quantity="2"  :mt="0">-->
<!--              <vs-input-->
<!--                v-validate="'required'"-->
<!--                data-vv-validate-on="input"-->
<!--                name="first name"-->
<!--                class="w-100"-->
<!--                :class="{'is-danger': errors.has('first name')}"-->
<!--                type="text"-->
<!--                label=" FIRST NAME"-->
<!--                placeholder="FIRST NAME"-->

<!--              />-->
<!--              <span class="text-danger help text " v-if="errors.has('first name')">{{ errors.first('first name') }}</span>-->
<!--            </smsc-col-item>-->
<!--          </smsc-col>-->
<!--        </div>-->
<!--      </div>-->


<!--    </div>-->
<!--  </vx-card>-->
  <vx-card>
    <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
      <div class="filters-container flex flex-wrap items-center justify-start">
    <div style="padding: 11px">
      <smsc-col>

        <smsc-col-item :col-quantity="4"  :mt="0">
          <div class="position-relative " style="top: 19px">
            <span class="fa fa-search search-icon "></span>
            <vs-input

              data-vv-validate-on="input"
              name="first name"
              class="w-100 text-indent "
              type="text"
              v-model="input_search"

            />
          </div>



        </smsc-col-item>
        <smsc-col-item :col-quantity="4"  :mt="0">
          <label class="vs-input--label">NPA</label>
          <v-select
            data-vv-validate-on="input"
            name="NPA"
            placeholder="Enter Npa"
            v-model="npa"
            label="name"
            :reduce="(option) => option.value"
            :options="npas"
          />
        </smsc-col-item>
        <smsc-col-item :col-quantity="4"  :mt="0">
          <label class="vs-input--label">COUNT</label>
          <v-select
            name="STATUS"
            placeholder="Enter Count"
            label="name"
            v-model="count"
            :reduce="(option) => option.value"
            :options="counts"
          />
        </smsc-col-item>
        <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
          <vs-button
            class="mt-3"
            @click="Order()"
          >Order</vs-button>
        </div>

        <smsc-col-item :col-quantity="4"  :mt="0">
          <label class="vs-input--label">LATA</label>
          <v-select
            data-vv-validate-on="input"
            name="LATA"
            placeholder="Enter Lata"
            v-model="lata"
            label="name"
            :reduce="(option) => option.value"
            :options="latas"
          />
        </smsc-col-item><smsc-col-item :col-quantity="4"  :mt="0">
          <label class="vs-input--label">STATE</label>
          <v-select
            data-vv-validate-on="input"
            name="STATE"
            placeholder="Enter State"
            v-model="state"
            label="name"
            :reduce="(option) => option.value"
            :options="states"
          />
        </smsc-col-item>
        <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
          <vs-button
            class="mt-3"
            @click="Search()"
          >Search</vs-button>
        </div>
      </smsc-col>
    </div>
      </div>
    </div>
    <!-- Per Page -->
    <!--      <div class="mb-4 md:mb-0">-->
    <!--        <per-page-->
    <!--          :currentPerPage="per_page"-->
    <!--          :pageStart="pageStart"-->
    <!--          :pageEnd="pageEnd"-->
    <!--          :total="total"-->
    <!--          @change-per-page="ChangePerPage($event)"-->
    <!--        />-->
    <!--      </div>-->

    <!-- Table -->
    <ag-grid-vue
      :components="components"
      :gridOptions="gridOptions"
      :class="{'noDataTable': !list.length}"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="list"
      @gridReady="GridReady"
      @filterChanged="Filtering"

      :animateRows="true"
      :floatingFilter="isFloatingFilter"
      :pagination="true"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
    >
    </ag-grid-vue>

    <!-- Pagination -->
    <vs-pagination
      :total="totalPages"
      :max="maxPageNumbers"
      v-model="Page" />
  </vx-card>
</div>

</template>

<script>
  import VueIpInput from 'vue-ip-input';
  import vSelect from 'vue-select'
  import { AgGridVue } from 'ag-grid-vue'
    export default {
      components: {
        AgGridVue,
        VueIpInput,
        vSelect
      },
        name: "ByDid",
      data:()=>({
        gridOptions:{},
        columnDefs: [
          {
            headerName: 'Number',
            field: 'number',
            minWidth: 220,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true
          },
          {
            headerName: 'State',
            field: 'state',
            minWidth: 220
          },
          {
            headerName: 'Lata',
            field: 'lata',
            minWidth: 220
          },
          {
            headerName: 'NPA',
            field: 'npa',
            minWidth: 220
          },

          {
            headerName: 'MRC',
            field: 'mrc',
            minWidth: 220
          },
          {
            headerName: 'NRC',
            field: 'nrc',
            minWidth: 220
          },


          /*{
            headerName: 'Action',
            flex: 0,
            cellRendererFramework: 'CellRendererActions',
            minWidth: 100,
          },*/

        ],
        state:'',
        lata:'',
        count:'',
        npa:'',
        input_search:'',
        selectedDidForBuy:[],
        counts: [
          { name: "10", value: "10" },
          { name: "20", value: "20" },
          { name: "30", value: "30" },
          { name: "50", value: "50" },
          { name: "100", value: "100" }
        ],
        npas:[],
        states:[],
        latas:[],
        dids: [],
        list:[],
      }),
      created() {
        this.getNpaList();
        this.getStateList();
        this.getLataList();
        this.GetList();
      },
      computed:{
        totalPages () {
          if (this.gridApi) return this.gridApi.paginationGetTotalPages()
          else return 0
        },
      },
      methods:{
        isActive(did) {
          // console.log(did,'111')
          if (!did.active){
            did.active = true
            this.selectedDidForBuy = [...this.selectedDidForBuy,did]
          }else{
            let newSelected = this.selectedDidForBuy.filter((item) => item !== did && did.active)
            this.selectedDidForBuy = newSelected
            did.active = false
          }
          console.log(this.selectedDidForBuy,'2222')

          this.selectedDid = did;
          // this.active = !this.active;
          // this.dids.map(item => {
          //   if (item == did) {
          //     did.active = !did.active;
          //   } else {
          //     item.active = false;
          //   }
          // });
        },
        Order(){

            let dataNumber = this.selectedDidForBuy.map((item)=> ({number: item.number}))
            if (this.selectedDidForBuy) {
              this.$store.dispatch("did/buyDid", { items: dataNumber })
                .then(res => {
                  if (
                    res.data.payload.items[0] &&
                    res.data.payload.items[0].status === "error"
                  ) {
                    res.data.payload.items.map(item => {
                      this.$snotify.error(item.error);
                    });
                  } else {
                    this.selectedDidForBuy = []
                    this.$success("DID has bed bought");
                    this.$router.push({ name: "company-admin-dids" });
                  }
                })
                .catch(err => this.$error(err));
            }
        },

        GetList() {
          this.loading = true;
          this.$store
            .dispatch("did/getAllSearchedDid", {
              npa: this.npa || "",
              pattern: this.pattern || "",
              state: this.state || "",
              lata: this.lata || "",
              count: this.count || 10
            })
            .then(res => {
              console.log(res.items, "<-------------GetList");
              this.list = res.items.map(this.TransformDids);
              console.log(this.list, "<-------------this.list");
              // this.TotalPages = res.total / res.per_page;
              // this.loading = false;
              if (this.list.length === 0) {
                this.$warning("No result found");
              }
            })
            .catch(err => this.$error(err))
            .finally(() => (this.loading = false));
        },
        getStateList() {
          this.$store
            .dispatch("did/getStateList")
            .then(res => {
              console.log(res,"<--------getStateList")
              let data = [];
              data.push({ name: "All", value: "" });

              res.items.map(item => {
                if (item.state) {
                  data.push({ name: item.state, value: item.state });
                }
              });
              this.states = data;
            })
            .catch(err => this.$error(err));
        },
        getLataList() {
          this.$store
            .dispatch("did/getLataList")
            .then(res => {
              console.log(res,"<--------getLataList")
              let data = [];
              data.push({ name: "All", value: "" });
              res.items.map(item => {
                if (item.lata) {
                  data.push({ name: item.lata, value: item.lata });
                }
              });
              this.latas = data;
            })
            .catch(err => this.$error(err));
        },
        getNpaList() {
          this.$store
            .dispatch("did/getNpaList")
            .then(res => {
              console.log(res,"<--------getNpaList")
              let data = [];
              data.push({ name: "All", value: "" });
              res.items.map(item => {
                if (item.npa) {
                  data.push({ name: item.npa, value: item.npa });
                }
              });
              this.npas = data;
            })
            .catch(err => this.$error(err));
        },
        getCountryList() {
          this.$store
            .dispatch("did/getCountryList", {
              nice_name: ""
            })
            .then(res => {
              console.log(res,"<--------getCountryList")
              this.countrys = res.items;
            });
        },
        Search() {
          this.GetList();
        },
        TransformDids(i, k) {
          return {
            number: i.number,
            location: i.area ? i.area.location : "",
            price: i.fees ? i.fees.price : "",
            type: i.type,
            mrc: i.mrc,
            nrc: i.nrc,
            state: i.state,
            lata: i.lata,
            npa: i.npa,
            active: false
          };
        },
      },
      mounted() {
        this.gridApi = this.gridOptions.api;
      }
    }
</script>

<style scoped>
  .search-icon{
    position: absolute;
    top: 12px;
    left: 20px;
    font-size: 22px;
    z-index: 46;
    color: gray;
  }
</style>
<style scoped lang="scss">
 .text-indent /deep/ .vs-input--input.normal{
   text-indent: 40px;
 }
</style>
